/** A sample trigger payload for the dry run, built so the flow's own conditions hold. */
import type { Condition, FlowDef } from './definition';
import type { TriggerInfo } from './sentence';

const SAMPLE_ID = '00000000-0000-4000-8000-00000000000';

function satisfying(c: Condition): unknown {
  const v = Array.isArray(c.value) ? c.value[0] : c.value;
  const n = Number(v);
  switch (c.op) {
    case '=':
    case 'in':
    case 'contains':
      return v;
    case '>=':
    case '<=':
      return Number.isNaN(n) ? v : n;
    case '>':
      return Number.isNaN(n) ? v : Math.round((n * 1.25 + (n === 0 ? 1 : 0)) * 100) / 100;
    case '<':
      return Number.isNaN(n) ? v : n - 1;
    case '!=':
    case 'not_in':
      return undefined;
    case 'exists':
      return c.field.endsWith('_id') ? `${SAMPLE_ID}1` : 'sample';
  }
}

export function samplePayload(def: FlowDef, trigger: TriggerInfo | undefined, ids: { vehicle?: string; driver?: string } = {}): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const f of trigger?.fields ?? []) {
    if (f.type === 'enum' && f.options?.length) out[f.key] = f.options[0];
    else if (f.type === 'number') out[f.key] = 1;
    else if (f.type === 'duration') out[f.key] = 600;
    else if (f.type === 'bool') out[f.key] = true;
  }
  const subject = trigger?.subject ?? 'none';
  if (subject === 'vehicle' || subject === 'asset') out.vehicle_id = ids.vehicle ?? `${SAMPLE_ID}2`;
  if (subject === 'vehicle' || subject === 'driver') out.driver_id = ids.driver ?? `${SAMPLE_ID}3`;
  if (def.trigger.type === 'telemetry.detection') out.detection_id = `${SAMPLE_ID}4`;
  if (subject !== 'none') {
    out.subject_type = subject;
    out.subject_id = subject === 'driver' ? out.driver_id : out.vehicle_id;
  }
  for (const c of [...def.trigger.where, ...def.conditions]) {
    const v = satisfying(c);
    if (v !== undefined && c.field && !c.field.includes('.')) out[c.field] = v;
  }
  return out;
}
